/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2025-03-17 14:21:38
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2026-08-27 13:37:28
 * @FilePath: \qctsw-vue\packages\app\src\pages\complaint\hooks\list.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const tabs = [
  {
    name: '所有投诉',
    sub: [{
      name: '最新投诉',
      value: 1,
    }, {
      name: '今日投诉',
      value: 2,
    }, {
      name: '典型投诉',
      value: 3,
    }, {
      name: '一追到底',
      value: 4,
    }, {
      name: '最多评论',
      value: 5,
    }, {
      name: '图片投诉',
      value: 6,
    }, {
      name: '视频投诉',
      value: 7,
    }],
  },
  {
    name: '集体投诉',
    sub: [{
      name: '最新投诉',
      value: 1,
    }, {
      name: '最多宗数',
      value: 2,
    }, {
      name: '最多评论',
      value: 3,
    }, {
      name: '升幅最大',
      value: 4,
    }, {
      name: '热门投诉',
      value: 5,
    }],
  },
  {
    name: '多次投诉',
    sub: [{
      name: '最新投诉',
      value: 1,
    }, {
      name: '最多次数',
      value: 2,
    }, {
      name: '最多评论',
      value: 3,
    }],
  },
  {
    name: '一追到底',
    sub: [{
      name: '最新投诉',
      value: 4,
    }, {
      name: '已结案',
      value: 8,
    }],
  },
  {
    name: '最新回复',
    sub: [
      {
        name: '企业回复',
        value: 0,
      },
      {
        name: '车主反馈',
        value: 9,
      },

    ],
  },
]

export function getComplainTypeCode(type: string, sub: string): number {
  const typeIndex = Number(type)
  const subIndex = Number(sub)

  if (Number.isNaN(typeIndex))
    return tabs[0].sub[0].value
  if (Number.isNaN(subIndex))
    return tabs[typeIndex].sub[0].value

  const subItem = tabs[typeIndex].sub[subIndex]
  if (!subItem)
    return tabs[typeIndex].sub[0].value
  return subItem.value
}
